import type { CustomActionEntity } from 'api/models/mainservice';
import { useGetUserCustomActionButtonsQuery } from 'pages/settings/companySettings/components/customButtons/queries';

export const useCustomButtons = (entity: CustomActionEntity, isDetail: boolean) => {
  const userCustomButtons =
    useGetUserCustomActionButtonsQuery().data?.userCustomActionButtons || [];

  return userCustomButtons.filter(
    (button) => button.isDetail === isDetail && button.entity === entity
  );
};
